// Configurazione URL backend
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend-ristorante.fly.dev';

export default API_BASE_URL;
